import Cookies from 'js-cookie';
import config from '../../configs/config';

function applyCountryLanguage(countryId) {
  if (countryId === 40 || countryId === 254) {
    Cookies.set('language', 'eng');
  }

  if (countryId === 167) {
    Cookies.set('language', 'esp');
  }
}

export function persistLoggedUserSession(data) {
  Cookies.set('loggedin', 'true');
  Cookies.set('UserAccessToken', data.UserAccessToken);
  Cookies.set('DeviceAccessToken', '$2a$05$MV9Oq6fiI0aGU3gBecjQF.Y14D0kt.Dwh7kT123AzEA6DQed/UAjq');
  Cookies.set('FirstName', data.FirstName);
  Cookies.set('IdAgent', data.Id_Agent);
  Cookies.set('IdAgency', data.Id_Agency);
  Cookies.set('CountryUser', data.Country);
  Cookies.set('AgencyReservHotelId', data.AgencyReservHotelId);
  Cookies.set('AgentReservHotelId', data.AgentReservHotelId);
 

  applyCountryLanguage(data.Country);
}

export function redirectToAppHome() {
  window.location.href = config.basename;
}

export function clearLoggedUserSession() {
  Cookies.set('loggedin', 'false');
  Cookies.set('UserAccessToken', 'nonenone');
  Cookies.set('DeviceAccessToken', 'nonenone');
  Cookies.set('FirstName', '');
  Cookies.set('CountryUser', '');
  Cookies.set('AgencyReservHotelId', '');
  Cookies.set('AgentReservHotelId', '');
}

export function redirectToLogout() {
  window.location.href = `${config.basename}?logout=true`;
}
